'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _middleware = require('../../middleware');

var _paths = require('./paths');

var _paths2 = require('../events/paths');

var _getAdjudicatorsForEvent = require('../events/getAdjudicatorsForEvent');

var _getAdjudicatorsForEvent2 = _interopRequireDefault(_getAdjudicatorsForEvent);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

exports.default = function (feis_id, event_id, person_id) {
  return function (dispatch, getState) {
    return dispatch((0, _getAdjudicatorsForEvent2.default)(feis_id, event_id)).then(function (data) {
      return data.payload.forEach(function (a) {
        var adj_id = a.id;

        var commentIdsForPerson = (0, _paths2.getEventComment)(getState(), event_id, adj_id, person_id);

        if (commentIdsForPerson.size > 0) {
          return;
        }

        return dispatch(_defineProperty({
          feis_id: feis_id,
          event_id: event_id,
          adj_id: adj_id,
          person_id: person_id

        }, _middleware.CALL_API, {
          config: {
            url: (0, _paths.commentsPrefixUrl)(feis_id, event_id, adj_id, person_id)
          },
          types: ['GET_COMMENTS_START', 'GET_COMMENTS', 'GET_COMMENTS_ERROR']
        }));
      });
    });
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/comments/getCommentsForPerson.js
// module id = 622
// module chunks = 0